import Swiper from "swiper";
import {Autoplay, Navigation, Pagination} from "swiper/modules";
import {limitSwiperPagination, realIndexOf, resolveSliderLayout} from "../../../../eila-global/js/slider/sliderHelpers.js";

export function initVehicleInUseSlider() {
    for(const vehicleInUseBannerElement of document.querySelectorAll('.vehicleInUseBanner')) {
        const imageSlider = vehicleInUseBannerElement.querySelector('.vehicleInUseBanner__slider');
        const contentSlider = vehicleInUseBannerElement.querySelector('.vehicleInUseBanner__contentWrapper');

        if (!imageSlider || !contentSlider) continue;

        Swiper.use([Autoplay, Navigation, Pagination]);

        // Content Swiper (wird vom Bild-Swiper gesteuert)
        const contentSwiper = new Swiper(contentSlider, resolveSliderLayout(contentSlider, {
            allowTouchMove: false,
            loop: true,
            slidesPerView: 1
        }));

        const imageSwiper = new Swiper(imageSlider, resolveSliderLayout(imageSlider, {
            modules: [Autoplay, Navigation, Pagination],
            spaceBetween: 24,
            loop: true,
            slideToClickedSlide: true,
            centeredSlides: false,
            /*autoplay: {
                delay: 5000,
                pauseOnMouseEnter: true
            },*/
            navigation: {
                nextEl: vehicleInUseBannerElement.querySelector('.swiper-button-next'),
                prevEl: vehicleInUseBannerElement.querySelector('.swiper-button-prev'),
                addIcons: false
            },
            pagination: {
                el: vehicleInUseBannerElement.querySelector(".swiper-pagination"),
                clickable: true
            },
            breakpoints: {
                0: {slidesPerView: 1},
                768: {slidesPerView: 1},
                1025: {slidesPerView: 1.8}
            }
        }));

        limitSwiperPagination(imageSwiper);

        imageSwiper.on('slideChange', () => {
            const index = realIndexOf(imageSwiper);

            if (contentSwiper.params.loop) {
                contentSwiper.slideToLoop(index);
            } else {
                contentSwiper.slideTo(index);
            }
        });
    }
}
